import * as React from "react";
import { useEffect, useState } from 'react';
import { Stack, PrimaryButton } from '@fluentui/react';
import { localStorageAvailable } from '../utils/localStorage';
import { getDisplayNameFromLocalStorage, saveDisplayNameToLocalStorage } from '../utils/localStorage';
import { Field } from './field';
import { TeamsMeetingLinkLocator } from '@azure/communication-calling';
import { withTranslation, WithTranslation } from "react-i18next";

export interface HomeScreenProps extends WithTranslation {
    startCallHandler(callDetails: {
        displayName: string;
        acsFields?: AcsFields[];
        teamsLink?: TeamsMeetingLinkLocator;
    }): void;
    joiningExistingCall: boolean;
    meetingUrl: string;
    acsFields?: any;
    userProfile: any | null;
    startCustomVideoCall: (displayName: string) => void;
}

export interface AcsFields {
    name: string;
    required?: boolean;
    title?: string;
    value?: string;
    mask?: string;
}

const HomeScreen = (props: HomeScreenProps) => {
    const { startCallHandler } = props;
    const localize = props.t;
    const buttonText = localize("AcsIniciarAtendimento");

    // Get display name and email from local storage if available
    const defaultDisplayName = localStorageAvailable ? getDisplayNameFromLocalStorage() : null;

    const [displayName, setDisplayName] = useState<string | undefined>(defaultDisplayName ?? (props.userProfile ? props.userProfile.userName : undefined));
    const [acsFields, setAcsFields] = useState<AcsFields[]>([]);
    const teamsLink = { meetingLink: props.meetingUrl }

    useEffect(() => {
        if (props.acsFields) {
            setAcsFields(props.acsFields);

            if (props.userProfile?.acsFields) {
                props.userProfile?.acsFields.map((item: AcsFields, i: number) => {
                    if (props.acsFields.findIndex((x: AcsFields) => x.name == item.name) >= 0) {
                        props.acsFields[props.acsFields.findIndex((x: AcsFields) => x.name == item.name)].value = item.value;
                        setAcsFields(props.acsFields);
                    }
                });
            }
        }
    }, [props.acsFields]);

    return (
        <Stack
            wrap
            className="home-screen adjust"
        >
            <Field
                defaultValue={displayName}
                setName={setDisplayName}
                label={localize("AcsNome")}
                id={`name`}
                placeholder={localize("AcsNomeInfo")}
                errorMsg={localize("AcsNomeObrigatorio")}
                errorMsgChars={localize("AcsNomeLimite")}
                required
            />

            {props.acsFields &&
                <>
                    {props.acsFields.map((item: AcsFields, i: number) => {
                        return (
                            <Field
                                key={i}
                                setName={(v) => {
                                    const customFieldsCopy: AcsFields[] = [...acsFields];
                                    customFieldsCopy[i].value = v;

                                    setAcsFields(customFieldsCopy);
                                }}
                                defaultValue={
                                    props.userProfile?.acsFields ?
                                        props.userProfile?.acsFields[props.userProfile?.acsFields.findIndex((x: AcsFields) => x.name == item.name)].value
                                        :
                                        undefined
                                }
                                label={item.title}
                                id={item.name}
                                errorMsg={localize("AcsObrigatorio")}
                                errorMsgChars={localize("AcsLimite")}
                                required={item.required}
                                mask={item.mask}
                            />
                        );
                    })}

                    <PrimaryButton
                        text={buttonText}
                        disabled={!displayName || acsFields.some(o => o.required && !o.value)}
                        onClick={() => {
                            if (displayName) {
                                saveDisplayNameToLocalStorage(displayName);

                                startCallHandler({
                                    displayName,
                                    acsFields,
                                    teamsLink,
                                });
                            }
                        }}
                    />
                </>
            }

            {!props.acsFields &&
                <PrimaryButton
                    text={buttonText}
                    disabled={!displayName}
                    onClick={() => {
                        if (displayName) {
                            saveDisplayNameToLocalStorage(displayName);

                            startCallHandler({
                                displayName,
                                teamsLink,
                            });
                        }
                    }}
                />
            }

            {/*<PrimaryButton*/}
            {/*    text="Entrar com video customizado"*/}
            {/*    style={{ marginTop: 12 }}*/}
            {/*    disabled={!displayName}*/}
            {/*    onClick={() => {*/}
            {/*        if (displayName) {*/}
            {/*            props.startCustomVideoCall(displayName);*/}
            {/*        }*/}
            {/*    }}*/}
            {/*/>*/}
        </Stack>
    );
};

const homeScreenWithTranslation = withTranslation()(HomeScreen);
export default homeScreenWithTranslation;